import axios from '../../Uri'
import * as types from "../actionTypes/RatActionTypes";
import {takeEvery} from 'redux-saga/effects'
function* getTodaysIncome(buildingId){
    let data = yield axios.get(`bed/getBedsByBuildingId/${buildingId.buildingId}`)
      console.log(data);
}
function* PaymentSaga(){
    yield takeEvery(types.GET_BEDS_BY_BUILDINGID,getTodaysIncome)
}
export default PaymentSaga;